import React, {
  ReactNode, FC, forwardRef, useCallback, MouseEvent, KeyboardEvent, ComponentType, ForwardedRef, HTMLAttributes,
} from 'react';
import { TriggerType } from 'react-popper-tooltip';

import { Placement } from '@popperjs/core';
import KEY_CODES from '../../../constants/KEY_CODES';
import { TooltipRenderProps } from '../Tooltip/Tooltip';

export interface StatusTooltipProps {
  /** Tip message. */
  tip: ReactNode;
  /** Custom hidden message on the button. A default message is already defined. */
  children?: ReactNode;
  /** Type of the status button. */
  CustomButton: ComponentType<{ ref: ForwardedRef<HTMLButtonElement> } & HTMLAttributes<HTMLButtonElement>>;
  /** Determine when to show/hide the tooltip. */
  trigger?: TriggerType | TriggerType[];
  /** PopperJs placement option for the tooltip. */
  placement?: Placement;
}

const StatusTooltip: FC<StatusTooltipProps & TooltipRenderProps> = forwardRef<HTMLButtonElement, StatusTooltipProps & TooltipRenderProps>(({ tip, trigger, CustomButton, toggleTooltip, ...props }, ref) => {
  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    // When the tooltip is inside a label, this prevents the focus from being set to the input.
    event.preventDefault();
  }, []);

  const handleKeydown = useCallback((event: KeyboardEvent<HTMLButtonElement>) => {
    if ((event).keyCode === KEY_CODES.ENTER) {
      toggleTooltip();
    }
  }, [toggleTooltip]);

  return (
    <CustomButton
      data-testid="StatusTooltip"
      {...props}
      ref={ref}
      onClick={handleClick}
      onKeyDown={(handleKeydown)}
    />
  );
});

export default StatusTooltip;
